const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nenus: state => state.user.nenus,  
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  errorLogs: state => state.errorLog.logs,
  funs: state => state.user.funs  
}
export default getters
